import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from 'antd';
import React from 'react';

interface CardsProps {
    title?: string;
    desc: string;
    url: IconProp;
    color: string
}


const Cards: React.FC<CardsProps> = ({ title, desc, url, color }) => (
    <Card
        className="text-center pt-5 pb-0 text-white hover:scale-[1.025] transition-all duration-200"
        style={{ backgroundColor:color }}
        cover={<div className="flex justify-center items-center -mb-4" >
            <FontAwesomeIcon icon={url} style={{ color: "white", fontSize: "4rem" }} />
        </div>}
        bordered={false}
    >
        <h1 className='text-lg font-bold text-center'>{title}</h1>
        <p className='text-sm text-white  text-justify 0'>{desc}</p>
    </Card>
);

export default Cards;
